import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface creaditNoteReasonParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface creaditNoteReason {
    id?: any;
    cNReasonName:string;
}


export abstract class creaditNoteReasonData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<creaditNoteReason[]>;
    abstract create(url: string, data: creaditNoteReason): Observable<creaditNoteReason[]>;
    abstract update(url: string, data: creaditNoteReason): Observable<creaditNoteReason>;
    abstract delete(url: string): Observable<any>;
}
